import DataTableImport from 'react-data-table-component';

export type { TableColumn } from 'react-data-table-component';

const DataTable = ((DataTableImport as any).default ??
  DataTableImport) as typeof DataTableImport;

export default DataTable;
